import React from "react";
import { AccordionItem, AccordionList } from "Components/Accordion";
import { Container } from "Components/ReactstrapSlim";
import classes from "./FAQSection.module.scss";

const questionsAndAnswers: AccordionItem[] = [
   {
      title: "How does LiquidSpace work for enterprises?",
      description: "LiquidSpace helps enterprises manage the entire lifecycle of flexible workplace programs. Employees book desks, offices, and meeting rooms on demand. Admins set policies, manage budgets, and track workspace usage across teams. Leaders use built-in intelligence tools to optimize their real estate footprint—balancing cost, productivity, and employee satisfaction.",
   },
   {
      title: "What types of workspaces can teams book with LiquidSpace?",
      description: "Teams can book desks, meeting rooms, private offices, team suites, dedicated, private office hubs, training rooms, and event spaces—available by the hour, day, or month. With 100,000+ workspaces across 3,500+ cities, employees can find office space wherever business happens, from coworking venues, hotels, landlords, and private companies with space to share.",
   },
   {
      title: "How does LiquidSpace support workspace governance?",
      description: "Workplace Manager lets workplace administrators, team managers, or HR leaders define who can book, where they can book, and how much they can spend. Set rules by role, region, or department—ensuring flexibility with full control.",
   },
   {
      title: "Does LiquidSpace help optimize real estate and reduce costs?",
      description: "Absolutely. Tools like Hub Locator and Scenario Modeler analyze employee behavior, market rates, and commute patterns to reveal optimization opportunities. Enterprises use LiquidSpace to reduce fixed office spend, improve utilization, and make smarter lease vs. flex decisions—often cutting costs by 50–80%.",
   },
   {
      title: "Is LiquidSpace secure and compliant for large organizations?",
      description: "Yes. LiquidSpace is scale-proven with global enterprise customers, and meets enterprise-grade standards for security, privacy, and financial compliance. We integrate with platforms like Okta, Azure AD, Workday, Slack, and Microsoft Teams to support SSO, provisioning, secure data flows, and seamless collaboration. All transactions and licenses are tracked for full auditability, with reporting tools that meet the needs of finance, HR, and compliance teams.",
   },
] 

const FAQSection: React.FC = () => {
   
   return (
      <section id="faq" className={classes.section}>
         <Container>
            <div className={classes.container}>
               <div className={classes.caption}>
                  <div className={classes.captionTitle}>
                     Your questions,<br/>
                     answered.
                  </div>
                  <div className={classes.captionSubtitle}>
                     Quick answers about how LiquidSpace powers the hybrid workplace strategies of leading enterprises. 
                  </div>
               </div>
               <div className={classes.content}>
                  <AccordionList items={questionsAndAnswers} />
               </div>
            </div>
         </Container>
      </section>
   );
};

export default FAQSection;
